import { AxiosResponse } from 'axios';
import apiClient from '../../../../shared/infrastructure/api/client';
import { CouplePatientChatRequest, CouplePatientChatResponse } from '../../domain/CouplePatientChat';

export const CouplePatientChatApiService = {
  sendMessage: (
    couplePatientId: string,
    payload: CouplePatientChatRequest,
  ): Promise<AxiosResponse<CouplePatientChatResponse>> =>
    apiClient.post(`/couple-patients/${couplePatientId}/chat`, payload),
};
